const Companyregistrationslists = {
    "type": "companyregistrationslists",
    "key": "companyregistrationslists",
    "order": 0,
    "options": {
        "alignitem": "center",
     },
    "components": [

    ]
}

export default Companyregistrationslists